import { useContext, useEffect } from 'react';
import { useState } from 'react';
import { AdminContext } from '../../contexts/contexAdmin';
import { StatusUser, UserAdmin } from '../../styles/admin';
import { RiUserAddFill } from 'react-icons/ri';
import { FaUserEdit } from 'react-icons/fa';
import { ImBin } from 'react-icons/im';
import { FaBluetooth } from 'react-icons/fa6';
import { HomeContext } from '../../contexts/contexHome';

export const AdminUser = () => {
  const {
    usersSave,
    modalCreatingUser,
    setModalCreatingUser,
    setSaveUserId,
    modalUserDeletConfirmation,
    setModalUserDeletConfirmation,
    modaUpdatePassword,
    setModalUpdatePassword,
    modalEditUser,
    setModalEditUser,
    modalBTGtw,
    setModalBTGtw,
    setSaveUserGtw,
    uservalidation,
  } = useContext(AdminContext);

  const { socket } = useContext(HomeContext);

  useEffect(() => {
    if (!socket) return;
    socket.on('user_updated', (userData) => {
      uservalidation();
    });
    socket.on('changed_user', (userData) => {
      uservalidation();
    });
  }, [socket]);

  return (
    <UserAdmin>
      <div className="Header">
        <h2>Usuários</h2>
        <div className="addIcon">
          <RiUserAddFill
            onClick={() => {
              setModalCreatingUser(!modalCreatingUser);
            }}
          />
          <span>Criar Um Novo Usuários</span>
        </div>
      </div>
      <ul>
        {usersSave.map((user) => {
          return (
            <li key={user.id}>
              <ImBin
                className="iconBin"
                onClick={() => {
                  setSaveUserId(user.id);
                  setModalUserDeletConfirmation(!modalUserDeletConfirmation);
                }}
              />
              {user.gateway != null && (
                <FaBluetooth
                  className="btConfig"
                  onClick={() => {
                    setSaveUserGtw(user.gateway);
                    setModalBTGtw(!modalBTGtw);
                  }}
                />
              )}
              <FaUserEdit
                className="iconEdit"
                onClick={() => {
                  setSaveUserId(user.id);
                  setModalEditUser(!modalEditUser);
                }}
              />
              <StatusUser color={user.online ? 'rgba(41, 162, 11, 1)' : 'rgba(131, 131, 131, 0.6)'}>
                <span className="online"></span>
                <span>{user.online ? 'Online' : 'Offline'}</span>
              </StatusUser>
              <span>E-mail : {user.email ? user.username : '--'}</span>
              <span>Usuário : {user.usuario}</span>
              <span>Nome : {user.nome}</span>
              <span>Conta Ativa : {user.is_active ? 'Sim' : 'Não'}</span>
              <span>Admin : {user.role > 2 ? 'Sim' : 'Não'}</span>
              <span>Nivel : {user.role}</span>
              <button
                onClick={() => {
                  setSaveUserId(user.id);
                  setModalUpdatePassword(!modaUpdatePassword);
                }}
              >
                Alterar Senha
              </button>
              <button
                onClick={() => {
                  setSaveUserId(user.id);
                  setModalEditUser(!modalEditUser);
                }}
              >
                Editar Usuário
              </button>
            </li>
          );
        })}
      </ul>
    </UserAdmin>
  );
};
